import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';

import { prepareData } from './helpers';

import { getClientDefaultSearchSelector } from 'store/selectors/user';
import { onBoardingSignUpSearchEffect } from 'store/effects';
import { addSearchInstance } from 'store/effects/clientInstances';
import { communities } from 'pages/Properties/CriteriaModal/constants';

import { Select } from 'components';
import { useEffect } from 'react';
import { useDebounce } from 'hooks/use-debounce';

const SeniorCommunityForm = (props) => {
  const { stageIndex } = props;
  const dispatch = useDispatch();
  const defaultClientSearch = useSelector(getClientDefaultSearchSelector);

  const formik = useFormik({
    initialValues: {
      SeniorCommunity: defaultClientSearch?.SeniorCommunity || [],
    },
    onSubmit(values) {
      const cfg = prepareData(values, stageIndex, defaultClientSearch);
      dispatch(
        onBoardingSignUpSearchEffect(cfg, {}, (err) => {
          if (!err) {
            dispatch(addSearchInstance({ data: cfg.DefaultPropertySearchPreferences }));
          }
        }),
      );
    },
  });

  const debounced = useDebounce(formik.values?.SeniorCommunity);

  useEffect(() => {
    if (formik.dirty) {
      formik.handleSubmit();
    }
  }, [debounced]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <Select
        options={communities}
        value={formik.values?.SeniorCommunity}
        onSelect={(_, { value }) => formik.setFieldValue('SeniorCommunity', value)}
        variant={Select.LIGHT_ROUND}
        label={'55+ Communities'}
      />
    </form>
  );
};

export default SeniorCommunityForm;
